import Vue from "vue";
import Router from "vue-router";
// 学生空间
import studentSide from "./studentSide";
// 天津轻工
import tianJin from "./tianJin";

import pdfs from "./pdfs";
import aiTraining from "./aiTraining";
Vue.use(Router);

import { Message } from "element-ui";
import { getToken, removeToken } from "@/utils/auth";
import store from "../store";

const hasToken = getToken();
const createRouter = new Router({
  scrollBehavior: function(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 };
  },
  routes: [...studentSide, ...tianJin, ...pdfs, ...aiTraining]
});
export default createRouter;



// WEBPACK FOOTER //
// ./src/router/index.js